import cart from '../helpers/cart-helper'
import device from '../helpers/device'
import refs from '../helpers/refs'
import priceHelper from '../helpers/price'
import formHelper from '../helpers/form'
import ButtonHelper from '../helpers/button-helper'
import CGiftCardRecipientForm from './c-gift-card-recipient-form'

class CProductInfo {
  constructor (el) {
    this.$root = el
    this.$refs = refs(el)

    this.multipleVariants = this.$refs.variantSelect !== undefined
    this.variantID = cart.getDefaultVariantID()
    // Handle is required to get info about product object
    this.productHandle = cart.getProductHandle()
    this.soldOut = !this.variantID

    // gift card recipient form vars
    this.isGiftCard = cart.getGiftCardStatus()
    this.productToAdd = {}
    this.errorMessages = {}
    // gift card recipient form
    // only allows one form, but there should only ever be one
    this.giftCardRecipientForm = new CGiftCardRecipientForm(document.querySelector('.c-gift-card-recipient-form'))

    // Right now quantity is always 1; Future proofing if quantity selector is added
    this.quantity = 1

    this.init()
  }

  init () {
    // Recommended accessories
    if (this.$refs.toggleRecco) {
      if (!Array.isArray(this.$refs.toggleRecco)) {
        this.$refs.toggleRecco = [this.$refs.toggleRecco]
      }

      this.$refs.toggleRecco.forEach((node) => {
        node.addEventListener('click', () => {
          this.toggleRecco(node)
        })
      })
    }

    // Show more description
    this.$refs.showMoreMobile.addEventListener('click', (e) => {
      this.$refs.showMoreMobile.classList.add('hidden')
      this.$refs.showMoreDesktop.classList.add('hidden')

      const description = document.getElementById('c-product-info__copy')
      description.classList.remove('c-product-info__copy')
    })

    // Show retailers
    if (this.$refs.showRetailers) {
      this.$refs.showRetailers.addEventListener('click', (e) => {
        e.preventDefault()
        e.stopPropagation()

        document.dispatchEvent(new CustomEvent('retailers:show'))
      })
    }

    // Out-of-stock overlay
    if (this.$refs.openOverlay) {
      this.$refs.openOverlay.addEventListener('click', () => {
        const overlay = document.getElementById('c-out-of-stock__overlay')
        overlay.classList.replace('hidden', 'flex')
      })
    }

    // On change of variant, update price
    if (this.multipleVariants) {
      this.$refs.variantSelect.addEventListener('change', () => {
        this.variantID = this.$refs.variantSelect.value

        this.updateUpsells()

        this.updatePrices()
        this.updateAddToCartButtonState()
      })
    }

    if (this.multipleVariants || (!this.multipleVariants && !this.soldOut)) {
      // NOTE: Not using $refs since add-to-cart buttons outside this component are wanted
      // Specify section.product-section to avoid product cards with add-to-cart buttons
      // No add to cart button on international sites
      if (document.querySelectorAll('section.product-section [ref="addToCartButton"]')) {
        document
          .querySelectorAll('section.product-section [ref="addToCartButton"]')
          .forEach((button) => {
            const innerElem =
              button.children.length > 0 ? button.children[0] : button
            const buttonHelper = new ButtonHelper(button, innerElem)

            button.addEventListener('click', (e) => {
              // Handle iOS Safari's buggy click event behavior
              e.preventDefault()
              e.stopPropagation()

              const isDesktop = device.isDesktop()

              // Set text to loading
              buttonHelper.setPendingState()

              // Add main product + accessories to cart
              // isDesktop is for whether the slideOut cart should be shown
              this.productToAdd = {
                id: this.variantID,
                quantity: this.quantity
              }

              // get gift card recipient info
              if (this.isGiftCard && this.giftCardRecipientForm.form !== null && this.giftCardRecipientForm.checkboxInput.checked) {
                const recipientInfoValid = this.validateGiftCardRecipient()
                // if not valid, can we link to c-gift-card-recipient-form.js to display messages?
                if (!recipientInfoValid) {
                  // Reset button to initial state
                  innerElem.innerText = 'Add to cart'
                  innerElem.style.animationPlayState = 'running'
                  button.classList.remove('bg-white')
                  button.classList.remove('text-orange')
                  return false
                } else {
                  this.giftCardRecipientForm.clearErrorMessage()
                }

                const giftRecipientNodes = this.$root.querySelectorAll('.recipient-form input,.recipient-form textarea') ? this.$root.querySelectorAll('.recipient-form input, .recipient-form textarea') : null
                const giftRecipient = {}
                if (giftRecipientNodes) {
                  giftRecipientNodes.forEach((field) => {
                    giftRecipient[field.getAttribute('name')] = field.value
                  })
                  /*
                  https://shopify.dev/docs/api/ajax/reference/cart#add-line-item-properties
                  Should be formatted like
                  items: [
                    {
                      quantity: 1,
                      id: 794864229,
                      properties: {
                        'First name': 'Caroline'
                      }
                    }
                  ]
                  */
                }

                this.productToAdd.properties = giftRecipient
              }
              cart
                .addProductsToCart(
                  [
                    this.productToAdd,
                    ...this.getSelectedAccIDs().map(id => ({
                      id,
                      quantity: 1
                    }))
                  ],
                  isDesktop
                )
                .then(() => {
                  if (isDesktop) {
                    // Update button visuals
                    buttonHelper.setDoneState()

                    // Reset to initial state
                    buttonHelper.resetStateOnDelay()
                  } else {
                    // Update button visuals
                    buttonHelper.setDoneState()

                    // Instead of showing slideOut cart on mobile, go to cart page
                    window.location.href = '/cart'
                  }
                })
            })
          })
      }

      // Sometimes the page loads with option already checked, make sure pricing is reflected
      this.updatePrices()
    }
  }

  validateGiftCardRecipient () {
    const validEmail = formHelper.validEmail(this.$root.querySelector('[name="Recipient email"]').value)
    // should be stopped by HTML, but easy to check
    const validMessage = this.$root.querySelector('[name="Message"]').value.length < 201
    if (!validEmail) {
      this.errorMessages.email = 'Please enter a valid email address'
    }
    if (!validMessage) {
      this.errorMessages.message = 'Message must be less than 200 characters long'
    }
    this.giftCardRecipientForm.displayErrorMessage('Please fix the following errors', this.errorMessages)
    // no need to validate date - have set min date of today in date picker
    // If it's needed in the future, note __shopify_offset is minutes. Positive for behind UTC (US/Canada) and negative for ahead of UTC (France, Germany, Russia)
    return validEmail && validMessage
  }

  getSelectedAccIDs () {
    const accessories = Array.from(
      document.querySelectorAll('[ref="toggleRecco"] > input:checked')
    )
    return accessories.map(acc => acc.parentNode.dataset.accessoryId)
  }

  toggleRecco (node) {
    node.classList.toggle('--selected')

    /* Do not manually update checkbox,
       b/c we are using a <label> which does this automatically
    const input = node.querySelector('input')
    input.checked = !input.checked
    */

    this.updatePrices()
  }

  updatePrices () {
    // Get default variant pricing
    let price = parseInt(cart.getDefaultVariantPrice())
    let comparePrice = parseInt(cart.getDefaultVariantComparePrice())

    // If multiple variants, get the selected variant price instead
    if (this.multipleVariants) {
      const selectedVariant = this.$root.querySelector(
        `option[value="${this.$refs.variantSelect.value}`
      )
      price = parseInt(selectedVariant.dataset.variantPrice)
      comparePrice = parseInt(selectedVariant.dataset.variantComparePrice) || 0
    }
    comparePrice = comparePrice === 0 ? price : comparePrice

    // Update prices - always do because might be a variant change
    const mainPriceElem = document.querySelector('#main-product-price')
    mainPriceElem.innerText = price === 0 ? 'FREE' : priceHelper.formatPrice(price)

    const mainPriceCompareElem = document.querySelector('#main-product-compare-price')
    if (mainPriceCompareElem) {
      mainPriceCompareElem.innerText = comparePrice === price ? '' : priceHelper.formatPrice(comparePrice)
    }

    // No recommendations or total prices on international sites
    if (document.querySelectorAll('[ref="toggleRecco"]').length > 0) {
      // Get pricing data from data attributes
      const accessories = Array.from(
        document.querySelectorAll('[ref="toggleRecco"] > input:checked')
      )
      const accPrices = accessories.map(acc =>
        parseInt(acc.parentNode.dataset.accessoryPrice)
      )
      const accComparePrices = accessories.map(acc =>
        acc.parentNode.dataset.accessoryComparePrice && acc.parentNode.dataset.accessoryComparePrice !== '' && parseInt(acc.parentNode.dataset.accessoryComparePrice) !== 0
          ? parseInt(acc.parentNode.dataset.accessoryComparePrice)
          : parseInt(acc.parentNode.dataset.accessoryPrice)
      )

      // Calculate total prices
      const totalPrice = accPrices.reduce((acc, curr) => acc + curr, price)
      const totalComparePrice = accComparePrices.reduce(
        (acc, curr) => acc + curr,
        comparePrice
      )

      // Update UI with total price
      for (const priceElem of document.querySelectorAll('[ref="price"]')) {
        if (priceElem.id === 'main-product-price') {
          // Don't change the main product price with the total price
        } else {
          // Not main product price - update with total price
          priceElem.innerText = totalPrice === 0 ? 'FREE' : priceHelper.formatPrice(totalPrice)
        }
      }
      for (const comparePriceElem of document.querySelectorAll('[ref="comparePrice"]')) {
        // Don't change the main product price with the total price
        if (comparePriceElem.id === 'main-product-compare-price') {
          // Don't change the main product price with the total price
        } else {
          // Not main product price - update with total price
          comparePriceElem.innerText = totalComparePrice === totalPrice ? '' : priceHelper.formatPrice(totalComparePrice)
        }
      }

      // Set total price label depending on whether accessories are selected
      document.querySelector('[ref="totalLabel"]').innerText = accessories.length > 0 ? 'Estimated Total:' : 'Total:'
    }
  }

  updateAddToCartButtonState () {
    if (this.multipleVariants) {
      const selectedVariant = this.$root.querySelector(
        `option[value="${this.$refs.variantSelect.value}`
      )

      // there will not be a selected variant on intl sites
      if (selectedVariant.length > 0) {
        const variantInStock =
          selectedVariant.dataset.variantAvailable === 'true'

        // If variant is in stock, enable add to cart button
        document
          .querySelectorAll('section.product-section [ref="addToCartButton"]')
          .forEach((button) => {
            button.classList.toggle('hidden', !variantInStock)
          })

        // If variant is out of stock, show sold out button
        document
          .querySelectorAll('section.product-section [ref="soldOutButton"]')
          .forEach((button) => {
            button.classList.toggle('hidden', variantInStock)
          })
      }
    }
  }

  updateUpsells () {
    if (this.$refs.toggleRecco) {
      this.$refs.toggleRecco.forEach((node) => {
        // uncheck - works, but commenting on the assumption customer would still want it
        // document.querySelector('[ref="toggleRecco"] > input').checked = false

        const allVariantData = JSON.parse(node.dataset.accessoryAllVariants)
        const selectedSize = this.$refs.variantSelect.options[this.$refs.variantSelect.selectedIndex].text.replace(/[\u2122\u00ae]/g, '')

        if (allVariantData) {
          allVariantData.forEach((variant) => {
            const variantSize = variant.title.replace(/[\u2122\u00ae]/g, '')
            if (variant.available && variantSize === selectedSize) {
              node.ariaLabel = `Add the ${variant.name} for ${variant.price / 100}`
              node.dataset.accessoryId = variant.id
              node.dataset.accessoryPrice = variant.price
              node.dataset.accessoryComparePrice = variant.compare_at_price ? variant.compare_at_price : ''
              node.dataset.accessorySize = variant.title
              node.querySelector('.price-span').innerText = `$${variant.price / 100}`
              node.classList.remove('hidden')
              this.updatePrices()
            } else if (variantSize === selectedSize) {
              node.classList.add('hidden')
            }
          })
        }
      })
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document
    .querySelectorAll('[data-c-product-info]')
    .forEach(el => new CProductInfo(el))
})
